'use client';
import React from 'react';
import Button from '@pezeshk-book/ui-kit/button';
import Div from '@pezeshk-book/ui-kit/div';
import Modal from '@pezeshk-book/ui-kit/modal';
import RadioButton from '@pezeshk-book/ui-kit/radio-button';
import Text from '@pezeshk-book/ui-kit/text';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import { PharmaciesActions } from '@store/pharmacies/pharmacies-actions';
import { useRouter } from 'next-nprogress-bar';
import { SelectCityModalProps } from './select-city-modal.props';
import { AuthActions } from '@store/auth/auth-actions';
import routes from '@routes';
import getParseRoute from '@utils/helpers/parse-route';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';

const SelectCityModal = ({ otc = false, loginRequire = false, prescription = false, electronicPrescription = false }: SelectCityModalProps) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { lang } = useParams<{lang: 'en'| 'fa'}>();
  const { services } = getDictionary(lang);
  const { city, cityHref, cityModal } = useSelector((state: RootState) => state.pharmacies);
  const { isLoggedIn } = useSelector((state: RootState) => state.auth);

  /*useEffect(() => {
    dispatch(PharmaciesActions.setResidenceCity({
      id: undefined,
      name: undefined,
      title: undefined
    }));
  }, [open]);*/

  const handleSelectCity = ({ id, cityName, title }: { id: string, cityName: string, title: string }) => {
    dispatch(PharmaciesActions.setResidenceCity({
      id: id,
      name: cityName,
      title: title,
    }));
  };
  const handleSubmit = () => {
    handleClose();
    if (otc || prescription || electronicPrescription) {
      dispatch(PharmaciesActions.pharmacyDataValidation({ type: electronicPrescription ? 'electronicPrescription' : prescription ? 'prescription' : 'otc' }));
    } else {
      if (loginRequire && !isLoggedIn) {
        dispatch(AuthActions.setLoginModal({ loginModal: true, redirectRoute: getParseRoute({ pathname: routes['route.pharmacies.checkout-upload'], locale: lang }) }));
      } else {
        router.push(getParseRoute({ pathname: cityHref || '', locale: lang }));
      }
    }
  };

  const handleClose = () => {
    dispatch(PharmaciesActions.setCityModal({ open: false }));
  };

  return (
    <Modal open={cityModal} onClose={handleClose}>
      <Div className={'flex-col bg-white w-10/12 p-4 sm:p-10 md:p-20 rounded-lg overflow-auto relative'}>
        <Text className={'self-start'} typography={'xl'} type={'bold'}>
          {services.online_pharmacy.city_modal.title}
        </Text>
        <Div className={'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-6 my-5'}>
          <Button endAdornment={<RadioButton color={'tertiary'} name={'city'} value={'tehran'} checked={city.name === 'tehran'}/>} variant={'outlined'} color={'control'} onClick={() => handleSelectCity({ id: 'Qyl0enAgpqz', cityName: 'tehran', title: 'تهران' })} className={'flex flex-row-reverse w-full px-7 items-center justify-between z-[5]'}>
            {services.online_pharmacy.city_modal.cities.vancouver}
          </Button>
          <Button endAdornment={<Text className={'whitespace-nowrap ml-4'} color={'tertiary'} typography={'sm'}>{services.online_pharmacy.city_modal.coming_soon}</Text>} variant={'outlined'} color={'control'} disabled={true} className={'flex flex-row-reverse w-full px-7 items-center justify-between z-[5]'}>
            {services.online_pharmacy.city_modal.cities.toronto}
          </Button>
        </Div>
        <Button disabled={!city.id} onClick={handleSubmit} href={getParseRoute({ pathname: otc || prescription ? '' : cityHref, locale: lang })} className={'w-full sm:w-96 self-center mt-5 md:mt-12'}>
          {services.online_pharmacy.city_modal.button}
        </Button>
      </Div>
    </Modal>
  );
};

export default SelectCityModal;
